var m = require('mithril');
var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');
var alerts= require('../../layout/components/alerts'); 
var headingElement = require('../../components/heading');
var AssetModel = require('../../../../../models/assets/asset');
var Model = require('../../libs/Model')
var Asset = Object.assign(AssetModel, Model);
var Point = {}

modal.once('closed', function () {
    key.deleteScope('modal');
    key.setScope('home');
  });
  
Point.editDialogue = function (record, options) {
    alerts.vm.clear();
    key.setScope('modal');
    Asset.initForm(record);
    if (record && record.point) {
      Asset.form.point(record.point);
    }

    modal.vm.title('Confirm Calibration Tracking'/* + record.name*/)
    modal.vm.body = Point.view,
    modal.vm.send = function(){
        Asset.save()
        .then(function(data){
            options && options.submitCallback ? options.submitCallback() : '';
            modal.vm.close()
        })
        .catch(function(e){
            alerts.vm.clear();
            alerts.vm.add({detail: e})
            console.log(e)
        })
    }
    modal.vm.buttons([
        {
            label: "Cancel",
            class: "f4 ba bw1 ph3 pv2 tc v-btm dib mr2",
            func: modal.vm.close.bind(modal)
        },
        {
            label: "Continue",
            class: "f4 ba bw1 ph3 pv2 tc v-btm dib mr2",
            func: modal.vm.send.bind()  
        }
    ]);
    modal.vm.open();
}

Point.view = function () {
    return m('form', {role:'form'}, [
        m('div', {class: 'alerts'}, alerts.view()),
        m('p', 'Are you sure you want to begin tracking calibrations for this device?'),
        m(headingElement, {label: 'Manufacturer'}),
        m('div.mb2',[
            m('input', {
              type: 'text',
              value: Asset.form.manufacturer(), 
              oninput: function (ev) { Asset.form.manufacturer(ev.target.value) }
            })
        ]),
        m(headingElement, {label: 'Model'}),
        m('div.mb2',[
            m('input', {
              type: 'text',
              value: Asset.form.model(), 
              oninput: function (ev) { Asset.form.model(ev.target.value) } 
            })
        ]),
        m(headingElement, {label: 'Probe Type'}),
        m('div.mb2',[
            m('input', {
              type: 'text',
              value: Asset.form.probeType(), 
              oninput: function (ev) { Asset.form.probeType(ev.target.value) } 
            })
        ]),
        m(headingElement, {label: 'Transmitter Serial Number'}),
        m('div.mb2',[
            m('input', {
              type: 'text',
              value: Asset.form.transmitterSerialNumber(), 
              oninput: function (ev) { Asset.form.transmitterSerialNumber(ev.target.value) } 
            })
        ]),
        m(headingElement, {label: 'Probe Serial Number'}),
        m('div.mb2',[
            m('input', {
              type: 'text',
              value: Asset.form.probeSerialNumber(), 
              oninput: function (ev) { Asset.form.probeSerialNumber(ev.target.value) } 
            })
        ]),
        
    ])
}

module.exports = Point;
